export default __webpack_public_path__ + "static/media/gccWeatherMonitor@2x.cf7081d7.jpg";